import type { PortableTextTypeComponentProps } from '@portabletext/react'
import clsx from 'clsx'
import type { FC } from 'react'

import type { CMSTableRow, CMSTableRowGroup } from '@/types/sanity'

export const Table: FC<
  PortableTextTypeComponentProps<{
    columnHeadings: string[]
    rowGroups: CMSTableRowGroup[]
    caption: string
  }>
> = ({ value }) => {
  const { columnHeadings, rowGroups, caption } = value
  return (
    <table className="section-rich-text-table">
      <thead className="section-rich-text-table__head">
        <tr className="section-rich-text-table__head-row type-label">
          {columnHeadings.map((heading: string, index: number) => (
            <th
              key={index}
              className="section-rich-text-table__heading"
              colSpan={index === 1 ? 2 : 1}
              // TODO: Replace
              // set:html={heading}
            >
              {heading}
            </th>
          ))}
        </tr>
      </thead>

      {rowGroups.map((rowGroup: CMSTableRowGroup) => (
        <tbody className="section-rich-text-table__body" key={rowGroup._key}>
          {rowGroup.rows.map((row: CMSTableRow, rowIndex: number) => {
            const rowClasses = [
              'section-rich-text-table__row',
              { 'section-rich-text-table__row--headed': rowIndex === 0 },
            ]

            return (
              <tr className={clsx(rowClasses)} key={row._key}>
                {row.cells.map((cell: string, cellIndex: number) => {
                  const isHeaderCell = rowIndex === 0 && cellIndex === 0

                  const Element = isHeaderCell ? 'th' : 'td'

                  const cellClasses = [
                    'section-rich-text-table__cell',
                    { 'section-rich-text-table__cell--header': isHeaderCell },
                    { 'type-label': isHeaderCell },
                  ]

                  return (
                    <Element className={clsx(cellClasses)} key={cellIndex}>
                      {cell}
                    </Element>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      ))}

      <caption className="section-rich-text-table__caption">{caption}</caption>
    </table>
  )
}
